import React from 'react';
import { Card, Badge } from '../ui';
import { useT } from '../../i18n';
import { setupMessages } from './setupMessages';
import './AddinDeploymentCard.css';

// The Gmail Add-on itself (Apps Script project + Marketplace domain-install)
// isn't built yet — see ROADMAP.md Phase 5B. This card is honest about that
// rather than showing a fake manifest/deployment ID the way
// AddinDeploymentCard does for the already-shipped Outlook add-in.
export const GmailAddonDeploymentCard = () => {
  const { t } = useT(setupMessages);
  return (
    <Card className="addin-deployment-card">
      <div className="addin-deployment-header">
        <div className="addin-deployment-title">
          <span className="addin-deployment-icon">📨</span>
          <h3>{t('gmailSoonTitle')}</h3>
        </div>
        <Badge variant="info">{t('soon')}</Badge>
      </div>

      <p className="addin-deployment-desc">{t('gmailSoonText')}</p>
    </Card>
  );
};

export default GmailAddonDeploymentCard;
